import React from 'react';
import Button from '../components/common/Button';
import themes from '../themes';

const HomePage = () => {
  return (
    <div className={'flex h-screen justify-center items-center'}>
      <div className={'flex gap-8'}>
        <Button buttonnumber={' 1'} text={'Bohren'} theme={themes.bohren} />
        <Button buttonnumber={' 2'} text={'Tragen'} theme={themes.tragen} />
        <Button buttonnumber={' 3'} text={'Ziehen'} theme={themes.ziehen} />
      </div>
    </div>
  );
};

export default HomePage;
